import { usePntAppControllerGetSegmentsFaceRecognitionsByDate } from '@mi-front/api-v2';
import { TimeRange, toDateTimeStr } from '@mi-front/core';
import { mapFaceRecognitionsToAppearances } from './map-appearances';
import { FaceRecognitionRangeItem, PersonAppearance } from './types';

const FACE_RECOGNITION_STALE_MS = 60_000;

const EMPTY: PersonAppearance[] = [];

/**
 * Apariciones de rostro para el rango de segmentos cargado.
 * Con `enabled=false` o rango vacío no consulta y devuelve `[]`.
 */
export function useFaceAppearances(
  slug: string,
  range: TimeRange<number>,
  enabled: boolean,
): { appearances: PersonAppearance[]; isLoading: boolean } {
  const queryEnabled = enabled && !!slug && range.from > 0 && range.to > range.from;
  const params = {
    from: toDateTimeStr(range.from),
    to: toDateTimeStr(range.to),
  };

  const { data, isLoading } = usePntAppControllerGetSegmentsFaceRecognitionsByDate(slug, params, {
    query: {
      enabled: queryEnabled,
      staleTime: FACE_RECOGNITION_STALE_MS,
      retry: false,
      // OpenAPI omits `filename`; runtime still sends it for absolute timestamps.
      select: (items) => mapFaceRecognitionsToAppearances(items as FaceRecognitionRangeItem[]),
    },
  });

  return { appearances: data ?? EMPTY, isLoading: queryEnabled && isLoading };
}
